import React from 'react'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns'
import FlagCircleIcon from '@mui/icons-material/FlagCircle'
import Typography from '@/v2/components/common/Typography'
import { getDateTimeWithoutTimezone } from '@/v2/utils/convert'
import { DAY_IN_US_FORMAT } from '@/v2/constants'
import { formatPhone } from '@/v2/utils/format'
import MessageStatus from '@/v2/containers/messages/MessageStatus'
import {
  Item,
  PatientSection,
  LastMessageWrapper,
  LastMessage,
  AutomatedTag,
  Badge,
} from './styles'
import PatientAvatar from '@/v2/components/common/PatientAvatar'

const Conversation = ({
  id,
  flagged,
  read,
  patients,
  phoneNumber,
  lastMessage,
  unreadMessagesCount,
}) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { conversationId } = useParams()

  // Determine patients array: if patient is already an array, use it; otherwise, wrap in array
  const patientsArray = Array.isArray(patients)
    ? patients
    : [patients].filter(Boolean)
  const firstPatient = patientsArray[0]
  const names = patientsArray
    .map(p => p.fullName || formatPhone(p.phoneNumber))
    .join(', ')

  return (
    <Item
      key={id}
      theme={theme.palette}
      selected={id === conversationId}
      onClick={() => navigate(`/v2/messages/${id}`)}
    >
      <div
        style={{ display: 'flex', alignItems: 'center', position: 'relative' }}
      >
        <PatientAvatar
          patient={firstPatient}
          names={names}
          size={46}
          sx={{ width: 46, height: 46, flexShrink: 0 }}
        />
        {patientsArray.length > 1 && (
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 30,
              background: theme.palette.primary.main,
              color: '#000',
              borderRadius: '10px',
              padding: '0 6px',
              fontSize: '12px',
              fontWeight: 500,
              minWidth: 20,
              textAlign: 'center',
              lineHeight: '20px',
            }}
          >
            +{patientsArray.length - 1}
          </div>
        )}
      </div>
      <PatientSection>
        <Typography fontSize="14px" fontWeight="500" lineHeight="18px">
          {names || formatPhone(phoneNumber)}
        </Typography>
        <LastMessageWrapper>
          <LastMessage>
            <Typography
              fontSize="14px"
              variant="h4"
              lineHeight="18px"
              className="last-message"
            >
              <MessageStatus
                type={lastMessage?.type}
                status={lastMessage?.deliveryStatus}
              />
              {lastMessage?.automated && (
                <AutomatedTag theme={theme.palette}>Auto</AutomatedTag>
              )}
              {lastMessage?.body || 'No message found'}
            </Typography>
          </LastMessage>
          {flagged && <FlagCircleIcon sx={{ fontSize: 18 }} />}
          {(!read || unreadMessagesCount > 0) && (
            <Badge theme={theme.palette}>{unreadMessagesCount || ''}</Badge>
          )}
        </LastMessageWrapper>
        <Typography
          fontSize="12px"
          variant="h4"
          lineHeight="18px"
          color={theme.palette.gray.main}
        >
          {lastMessage?.createdAt
            ? format(
                getDateTimeWithoutTimezone(lastMessage.createdAt),
                DAY_IN_US_FORMAT
              )
            : ''}
        </Typography>
      </PatientSection>
    </Item>
  )
}

export default Conversation
